import HBMessage from "@/components/HBMessage";
import { GDErrCode } from "@/constants/gaoding";
import useAppStore from "@/context/store";
import { getAccessToken, isUnifiedUser } from "./auth";
import createRequest from "./createRequest";
import { handleUserNotInOrg } from "./gaoding";
import { getHttpAgent } from "./getHttpAgent";

// yapi、dev、fat、stage、production
const API = {
  yapi: "https://yapi.gaoding.com/mock/1536",
  dev: "https://gd-dev.huaban.com/api",
  fat: "https://gd-fat.huaban.com/api",
  stage: "https://gd-stage.huaban.com/api",
  prod: "https://gd.huaban.com/api",
};
const CHANNEL_ID_MAP = {
  yapi: 281,
  dev: 281,
  fat: 240,
  stage: 289,
  prod: 289,
};

const BUSSINESS_ID_MAP = {
  yapi: 33,
  dev: 33,
  fat: 61,
  stage: 57,
  prod: 57,
};

export const env = process.env.NEXT_PUBLIC_DEPLOY_ENV || "prod";

export const BaseURL = API[env];
export const REQUEST_MESSAGE_KEY = "REQUEST_MESSAGE_KEY";

const axios = createRequest({
  BaseURL,
});

/**
 * 公共请求方法
 * @param {{
 *  url: string,
 *  params?: Object,
 *  query?: Object,
 *  ignoreMessage?: boolean,
 *  ignoreError?: boolean,
 *  serverSideHttps?: boolean,
 *  cache?: boolean | {time: number}
 * } & import('axios').AxiosRequestConfig} param
 * @returns {Promise<any>}
 */
const request = async (props) => {
  const {
    url = "/",
    params, // url匹配参数
    query, // 查询参数
    headers = {},
    ignoreMessage,
    ignoreError,
    serverSideHttps,
    ...opts
  } = props;

  const accessToken = await getAccessToken(headers?.cookie);

  try {
    return await axios({
      url,
      params: query,
      options: {
        params,
        ignoreMessage,
        ignoreError,
      },
      timeout: 10000,
      headers: {
        "X-Business-Id": BUSSINESS_ID_MAP[env],
        "X-Channel-Id": CHANNEL_ID_MAP[env],
        ...(accessToken &&
        isUnifiedUser(useAppStore.getState().user?.user_id, accessToken)
          ? {
              authorization: `Bearer ${accessToken}`,
            }
          : null),
        ...headers,
      },
      ...(typeof window === "undefined"
        ? {
            ...(!serverSideHttps
              ? { baseURL: BaseURL.replace("https", "http") }
              : null),
            httpAgent: getHttpAgent(),
          }
        : null),
      ...opts,
    });
  } catch (error) {
    const { response } = error;

    const errData = response?.data;

    // 处理用户不在租户里的错误
    if (
      errData?.code === GDErrCode.UserNotInOrg ||
      errData?.code === GDErrCode.UnBindOrg
    ) {
      const handleResult = await handleUserNotInOrg();
      if (handleResult) {
        // 处理成功后，重新发起请求
        return request(props);
      }
    }

    if (!ignoreError && typeof window !== "undefined") {
      let errmsg = error.toString();
      if (response?.data && response?.data?.message) {
        errmsg = response.data?.message;
      }

      HBMessage.error({
        content: errmsg,
        key: REQUEST_MESSAGE_KEY,
        duration: 3,
      });
    }

    return {
      data: response?.data,
      status: response?.status,
      error: response?.status !== 200,
      err: response?.status !== 200,
    };
  }
};

if (typeof window !== "undefined") {
  window.gdRequest = request;
}

export default request;
